import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const LibraryListLinks = (props) => (
  <span>
    <img src={props.img} alt={props.imgAlt} />
    <h4 className='epsilon'>{props.heading}</h4>
    <ul>
      {
        props.courses.map((course) => (
          <li key={course.id}>
            <NavLink to={'/courses/' + course.slug} activeClassName='is-selected'>{course.title} {props.postPend}</NavLink>
          </li>
        ))
      }
    </ul>
  </span>
);

LibraryListLinks.propTypes = {
  courses: PropTypes.array,
  heading: PropTypes.string,
  imgAlt: PropTypes.string,
  img: PropTypes.string
};

export default LibraryListLinks;



// WEBPACK FOOTER //
// ./src/components/LibraryListLinks/index.js